import React from 'react';
import Servicios from '../../components/servicios/Servicios';
import Layout from '../../components/layout/Layout';

const ServiciosPage = () => {
    return ( <Layout children={<Servicios />} /> )
}

export default ServiciosPage